<template>
  <div>
    <van-popup v-if="memberData" v-model="showDialog" position="bottom" @closed="onClosed">
      <van-row class="popTitle">
        <van-col span="4" />
        <van-col span="16" class="center" :style="'color:'+GetDiveMainBack()">{{ memberData.student.firstName }} {{ memberData.student.lastName }}的证书签发</van-col>
        <van-col span="4" class="rigth"><i class="iconfont iconrigthjt" @click="showDialog=false" /></van-col>
      </van-row>
      <div class="HeadRect">
        <div class="head">
          <van-image
            width="4em"
            height="5.2em"
            fit="cover"
            radius="0.4em"
            lazy-load
            :src="memberData.student.headIcon?memberData.student.headIcon:'/img/defaultUserIcon.jpg'"
          />
        </div>
        <div class="valueRect">
          <div class="values breakAll">
            <span :style="'color:'+GetDiveMainBack()">姓名: </span>{{ memberData.student.loaclName }} {{ memberData.student.lastName }} {{ memberData.student.firstName }} {{ memberData.student.sex }}
          </div>

          <div class="values breakAll">
            <span :style="'color:'+GetDiveMainBack()">生日: </span>{{ formatDate(memberData.student.birthday,'yyyy/MM/dd') }}
          </div>
          <div class="values breakAll">
            <span :style="'color:'+GetDiveMainBack()">邮箱: </span>{{ memberData.student.email }}
          </div>
          <div class="values breakAll">
            <span :style="'color:'+GetDiveMainBack()">电话: </span>{{ memberData.student.phoneCountry }} {{ memberData.student.phone }}
          </div>
        </div>
        <div class="values breakAll">
          <span :style="'color:'+GetDiveMainBack()">地址: </span>
          {{ memberData.student.country }}
          {{ memberData.student.cityEng }}
          {{ memberData.student.area }}
          {{ memberData.student.address }}
          ({{ memberData.student.postalCode }})
        </div>
        <template v-if="memberData.student.state ==='Wait' || memberData.student.state ==='OnTheoretical' || memberData.student.state ==='FinishTheoretical' || memberData.student.state ==='OnCourse'">
          <div class="unitRect">
            <!-- <table class="tableRect" cellspacing="0">
          <tr>
            <td />
          </tr>
        </table> -->

            <FieldSelect v-model="formData.groupTeam" :list="groupTeamList" label="潜水机构" placeholder="请选择潜水机构" @change="onGroupTeamChange" />
            <template v-if="formData.groupTeam==='PADI'">
              <FieldSelect v-model="formData.stundetCourseId" :list="padiCourse" label="证书级别" placeholder="请选择证书级别" @change="onStundetCourseId" />
              <van-field
                v-model="formData.startTime"
                required
                clearable
                label="结课日期"
                placeholder="请输入结课日期"
                readonly
                @click="showStartDate=true"
              />
            </template>
            <template v-if="formData.groupTeam==='AIDA'">
              <van-field
                v-model="formData.startTime"
                required
                clearable
                label="开课日期"
                placeholder="请输入开课日期"
                readonly
                @click="showStartDate=true"
              />
              <van-field
                v-model="formData.city"
                label="开课城市"
                required
                maxlength="64"
                placeholder="请输入教学所在城市"
              />
              <van-field
                v-model="formData.address"
                label="开课地址"
                maxlength="64"
                placeholder="请输入开课所在地"
              />
              <FieldSelect v-model="formData.classCourseId" :list="aidaCourseList" label="班级级别" placeholder="请选择班级级别" @change="onClassCourseId" />
              <FieldSelect v-model="formData.stundetCourseId" :list="aidaCourseListStuedent" label="学员级别" placeholder="请选择学员级别" @change="onStundetCourseId" />
              <van-tag v-for="(item,index) in unitList" :key="index" class="tagUnit" :type="item.select?'success':'danger'">{{ item.text }}</van-tag>
            </template>
            <van-field
              v-model="formData.proAccount"
              label="签发账号"
              readonly
              placeholder="未配置，请先在‘专业’中配置!"
            />
            <van-field
              v-model="formData.remark"
              rows="2"
              autosize
              type="textarea"
              maxlength="128"
              placeholder="请输入申请备注信息"
              class="inputRect"
            />
            <div class="checkBoxRect">
              <van-checkbox v-model="checkSuccess" :disabled="!isUserInfoSuccess" :checked-color="GetDiveMainBack()" class="checkBox">我已确定用户信息、照片准确无误.</van-checkbox>
              <div v-if="!isUserInfoSuccess" class="userInfoNotSuccess" :style="'color:'+GetDiveMainBack()">请先联系用户填写姓名、电话、电子邮箱、地址、上传头像。</div>
              <van-checkbox v-model="checkSuccess1" :checked-color="GetDiveMainBack()" class="checkBox">我已确认用户完成教学要求,达到证书要求.</van-checkbox>
            </div>
            <van-button :disabled="!checkSuccess || !checkSuccess1" :color="GetDiveMainBack()" size="small" style="width:100%" :loading="buttonLoading" @click="onSaveCertificate">提交签发</van-button>
          </div>
        </template>
        <template v-else>
          <div class="values breakAll">
            <span :style="'color:'+GetDiveMainBack()">签发教练: </span>
            {{ memberData.student.picVerifyCoachName }}
          </div>
          <div class="values breakAll">
            <span :style="'color:'+GetDiveMainBack()">提交日期: </span>
            {{ formatDate(memberData.student.picVerifySubjectTime,'yyyy/MM/dd hh:mm') }}
          </div>
          <div class="values breakAll">
            <span :style="'color:'+GetDiveMainBack()">申请备注: </span>
            {{ memberData.student.picVeriftRemark }}
          </div>
          <div v-if="applyData" class="values breakAll">
            <span :style="'color:'+GetDiveMainBack()">城市地址: </span>
            {{ applyData.city }}  {{ applyData.address }}
          </div>
          <div v-if="applyData" class="values breakAll">
            <span :style="'color:'+GetDiveMainBack()">机构: </span>
            {{ applyData.groupTeam }}
          </div>
          <div v-if="applyData" class="values breakAll">
            <span :style="'color:'+GetDiveMainBack()">日期: </span>
            {{ formatDate(applyData.startTime,'yyyy/MM/dd') }}
          </div>
          <div v-if="applyData && applyData.groupTeam==='AIDA'" class="values breakAll">
            <span :style="'color:'+GetDiveMainBack()">证书: </span>
            班级:{{ applyData.classCourseId }} 学员:{{ applyData.stundetCourseId }}
          </div>
          <div v-if="applyData && applyData.groupTeam==='PADI'" class="values breakAll">
            <span :style="'color:'+GetDiveMainBack()">证书: </span>
            {{ getPadiCourseName(applyData.stundetCourseId) }}

          </div>
        </template>
      </div>
    </van-popup>
    <dateSelect v-model="showStartDate" :default-date="baseDate" @onChange="onStartDateChanage" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Field, Image, Popup, Button, Checkbox, Tag } from 'vant'
import { GetEnumList, MyNotify, GetEnumText, formatDate } from '@/utils/base'
import { GetDiveMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import dateSelect from '@/components/dateSelect'
import FieldSelect from '@/components/FieldSelect'
export default {
  components: {
    [Field.name]: Field,
    [Image.name]: Image,
    [Popup.name]: Popup,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Tag.name]: Tag,
    dateSelect,
    FieldSelect
  },
  props: {
    // eslint-disable-next-line
    value: undefined,
  },
  data() {
    return {
      showDialog: false,
      memberData: undefined,
      buttonLoading: false,
      checkSuccess: false,
      checkSuccess1: false,
      isUserInfoSuccess: false,
      baseDate: undefined,
      showStartDate: false,
      groupTeamList: [],
      aidaCourseList: [],
      aidaCourseListStuedent: [],
      unitList: [],
      ThirdAccountList: [],
      applyData: undefined,
      padiData: {
        padiCountry: [],
        padiType: [],
        padiCourse: []
      },
      padiCourse: [],
      formData: {
        proAccount: undefined,
        studentId: undefined,
        startTime: undefined,
        remark: '',
        address: '',
        city: '',
        classCourseId: '',
        stundetCourseId: '',
        unitStr: '',
        groupTeam: ''
      }
    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        setTimeout(() => {
          this.groupTeamList = GetEnumList('Em_CertificationGroupType')
          this.formData.groupTeam = 'NONE'
        }, 1)
        this.checkSuccess = false
        this.checkSuccess1 = false
        this.memberData = newValue
        this.formData.studentId = this.memberData.student.studentId
        this.formData.startTime = formatDate(this.memberData.student.startTime, 'yyyy/MM/dd')
        this.baseDate = formatDate(this.memberData.student.startTime, 'yyyy/MM/dd')
        console.log('this.memberData', this.memberData)
        this.isUserInfoSuccess = this.checkUserInfoFinish(this.memberData)
        this.loadSaveCerData()
        this.showDialog = true
      } else {
        this.memberData = undefined
        this.showDialog = false
      }
    }

  },
  created() {
    this.onLoadPADIBaseData()
    this.loadThirdAccount()
  },
  methods: {
    GetDiveMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine,
    GetEnumText,
    formatDate,
    getPadiCourseName(id) {
      var ser = this.padiData.padiCourse.filter(item => item.value === id)
      if (ser.length <= 0) {
        return undefined
      }
      return ser[0].text
    },
    onGroupTeamChange(data) {
      this.formData.groupTeam = data.value
      this.formData.proAccount = ''
      var selectGroupType = this.ThirdAccountList.filter(item => item.groupType === data.value)
      if (selectGroupType.length > 0) {
        this.formData.proAccount = selectGroupType[0].account
      }

      if (this.formData.groupTeam === 'AIDA') {
        setTimeout(() => {
          this.aidaCourseList = []
          this.aidaCourseList.push({ text: 'AIDA1', value: 'AIDA1' })
          this.aidaCourseList.push({ text: 'AIDA2', value: 'AIDA2' })
          this.aidaCourseList.push({ text: 'AIDA2 Pool', value: 'AIDA2 Pool' })
          this.aidaCourseList.push({ text: 'AIDA3', value: 'AIDA3' })
          this.aidaCourseList.push({ text: 'AIDA3 Pool', value: 'AIDA3 Pool' })
          this.aidaCourseList.push({ text: 'AIDA4', value: 'AIDA4' })
        }, 1)
      } else if (this.formData.groupTeam === 'PADI') {
        // JSON.parse(JSON.stringify(this.dataList[0]))

        this.formData.address = ''
        this.formData.city = ''
        this.formData.classCourseId = ''
        this.formData.stundetCourseId = ''
        this.formData.unitStr = ''
        setTimeout(() => {
          this.padiCourse = []
          this.padiCourse = JSON.parse(JSON.stringify(this.padiData.padiCourse))
          this.formData.stundetCourseId = undefined
        }, 5)
      } else {
        this.formData.address = ''
        this.formData.city = ''
        this.formData.classCourseId = ''
        this.formData.stundetCourseId = ''
        this.formData.unitStr = ''
      }
    },
    onClassCourseId(data) {
      this.formData.classCourseId = data.value
      setTimeout(() => {
        this.aidaCourseListStuedent = []
        if (this.formData.classCourseId === 'AIDA1') {
          this.aidaCourseListStuedent.push({ text: 'AIDA1', value: 'AIDA1' })
          this.onStundetCourseId({ value: 'AIDA1' })
        } else if (this.formData.classCourseId === 'AIDA4') {
          this.aidaCourseListStuedent.push({ text: 'AIDA4', value: 'AIDA4' })
          this.onStundetCourseId({ value: 'AIDA4' })
        } else if (this.formData.classCourseId === 'AIDA3') {
          this.aidaCourseListStuedent.push({ text: 'AIDA3', value: 'AIDA3' })
          this.aidaCourseListStuedent.push({ text: 'AIDA3 Pool', value: 'AIDA3 Pool' })
          this.onStundetCourseId({ value: 'AIDA3' })
        } else if (this.formData.classCourseId === 'AIDA3 Pool') {
          this.aidaCourseListStuedent.push({ text: 'AIDA3 Pool', value: 'AIDA3 Pool' })
          this.onStundetCourseId({ value: 'AIDA3 Pool' })
        } else if (this.formData.classCourseId === 'AIDA2') {
          this.aidaCourseListStuedent.push({ text: 'AIDA2', value: 'AIDA2' })
          this.aidaCourseListStuedent.push({ text: 'AIDA2 Pool', value: 'AIDA2 Pool' })
          this.aidaCourseListStuedent.push({ text: 'AIDA1', value: 'AIDA1' })
          this.onStundetCourseId({ value: 'AIDA2' })
        } else if (this.formData.classCourseId === 'AIDA2 Pool') {
          this.aidaCourseListStuedent.push({ text: 'AIDA2 Pool', value: 'AIDA2 Pool' })
          this.aidaCourseListStuedent.push({ text: 'AIDA1', value: 'AIDA1' })
          this.onStundetCourseId({ value: 'AIDA2 Pool' })
        }
      }, 1)
    },
    loadThirdAccount() {
      request({
        url: '/pro/getThirdGroupAccountId',
        method: 'post'
      }).then(Response => {
        if (!Response.success) {
          return
        }
        this.ThirdAccountList = Response.data
      })
    },
    loadSaveCerData() {
      this.applyData = undefined
      request({
        url: '/DiveTrip/getFinishLearningVerifySubject',
        method: 'post',
        params: { id: this.memberData.student.studentId }
      }).then(Response => {
        if (!Response.success) {
          return
        }
        if (!Response.data) {
          return
        }
        this.applyData = Response.data
        this.onGroupTeamChange({ value: Response.data.groupTeam })
        this.formData.city = Response.data.city
        this.formData.address = Response.data.address
        if (Response.data.startTime) {
          this.formData.startTime = formatDate(Response.data.startTime, 'yyyy/MM/dd')
          this.baseDate = formatDate(Response.data.startTime, 'yyyy/MM/dd')
        }
        setTimeout(() => {
          this.onClassCourseId({ value: Response.data.classCourseId })
        }, 2)
      })
    },
    onStundetCourseId(data) {
      this.formData.stundetCourseId = data.value
      this.unitList = []
      if (this.formData.classCourseId === 'AIDA1') {
        this.unitList.push({ text: 'Medical Certificate', value: 4, select: true })
        this.unitList.push({ text: 'AIDA1 Pool Requirements', value: 6, select: true })
      } else if (this.formData.classCourseId === 'AIDA4') {
        this.unitList.push({ text: 'Theory Exam', value: 1, select: true })
        this.unitList.push({ text: 'Pool Requirements', value: 2, select: true })
        this.unitList.push({ text: 'Open Water Requirements', value: 3, select: true })
        this.unitList.push({ text: 'Medical Certificate', value: 4, select: true })
        this.unitList.push({ text: 'First Aid Certificate', value: 5, select: true })
      } else if (this.formData.classCourseId === 'AIDA3' || this.formData.classCourseId === 'AIDA3 Pool') {
        this.unitList.push({ text: 'Theory Exam', value: 1, select: true })
        this.unitList.push({ text: 'Pool Requirements', value: 2, select: true })
        this.unitList.push({ text: 'Open Water Requirements', value: 3, select: this.formData.stundetCourseId === 'AIDA3' })
        this.unitList.push({ text: 'Medical Certificate', value: 4, select: true })
      } else if (this.formData.classCourseId === 'AIDA2' || this.formData.classCourseId === 'AIDA2 Pool') {
        this.unitList.push({ text: 'Theory Exam', value: 1, select: true })
        this.unitList.push({ text: 'Pool Requirements', value: 2, select: this.formData.stundetCourseId === 'AIDA2' || this.formData.stundetCourseId === 'AIDA2 Pool' })
        this.unitList.push({ text: 'Open Water Requirements', value: 3, select: this.formData.stundetCourseId === 'AIDA2' })
        this.unitList.push({ text: 'Medical Certificate', value: 4, select: true })
        this.unitList.push({ text: 'AIDA1 Pool Requirements', value: 6, select: true })
      }
    },
    onStartDateChanage(date) {
      this.formData.startTime = date
    },
    checkUserInfoFinish(memberData) {
      var isOk = true
      if (!memberData.student.loaclName || memberData.student.loaclName === '') {
        isOk = false
      }
      if (!memberData.student.firstName || memberData.student.firstName === '') {
        isOk = false
      }
      if (!memberData.student.lastName || memberData.student.lastName === '') {
        isOk = false
      }
      if (memberData.student.type === 'COURSE') {
        if (!memberData.student.phone || memberData.student.phone === '') {
          isOk = false
        }
        if (!memberData.student.email || memberData.student.email === '') {
          isOk = false
        }
        if (!memberData.student.headIcon || memberData.student.headIcon === '') {
          isOk = false
        }
        if (!memberData.student.address || memberData.student.address === '') {
          isOk = false
        }
        if (!memberData.student.zip || memberData.student.zip === 0 || memberData.student.zip === '') {
          isOk = false
        }
      }
      return isOk
    },
    onClosed() {
      this.$emit('input', false)
    },
    onSaveCertificate() {
      if (this.formData.groupTeam === 'AIDA') {
        var unitStr = []
        this.unitList.forEach(item => {
          if (item.select) {
            unitStr.push(item.value)
          }
        })
        this.formData.unitStr = unitStr.join(',')
      } else if (this.formData.groupTeam === 'PADI') {
        this.formData.startaddressTime = undefined
        this.formData.city = undefined
        this.formData.classCourseId = undefined
        this.formData.unitStr = undefined
      } else {
        this.formData.startTime = undefined
        this.formData.startaddressTime = undefined
        this.formData.city = undefined
        this.formData.stundetCourseId = undefined
        this.formData.classCourseId = undefined
        this.formData.unitStr = undefined
      }

      this.buttonLoading = true
      request({
        url: '/DiveTrip/FinishLearningVerifySubject',
        method: 'post',
        data: this.formData
      }).then(Response => {
        this.buttonLoading = false
        if (!Response.success) {
          return
        }
        MyNotify('success', '提交认证材料成功', 2000)
        this.showDialog = false
        this.$emit('reload')
      })
    },
    onLoadPADIBaseData(callback) {
      if (this.padiData.padiCourse.length > 0) {
        if (callback) {
          callback()
        }
        return
      }
      request({
        url: '/DiveTrip/getPicOrgBaseData',
        method: 'post'
      }).then(Response => {
        if (!Response.success) {
          return
        }
        this.padiData = Response.data
        this.padiData.padiCourse.forEach(item => {
          item.text = item.name
          item.value = item.value + ''
        })
        if (callback) {
          callback()
        }
      })
    }

  }
}
</script>

<style scoped>
 .HeadRect{
  position: relative;
  overflow: hidden;
  padding: 1em;
}
 .HeadRect .head{
  position: absolute;
  left: 1em;
  top: 1em;
}
 .HeadRect .valueRect{
  padding-left: 5em;
  min-height: 5.2em;
}
 .HeadRect .values
 {
   font-size: 0.8em;
   padding: 0.15em 0;
 }
.checkBoxRect{
    padding: 0.5em 0;
}
.checkBoxRect .checkBox{
    padding: 0.25em 0;
    font-size: 0.9em;
}
.popTitle
{
  padding: 0.5em 0.5em;
  border-bottom: 1px solid #f5f5f5;
}
.inputRect{
    margin: 0.5em 0;
    padding: 0.5em;
    border: 1px solid #f5f5f5;
}
.userInfoNotSuccess{
  font-size: 0.6em;
}
.tagUnit{
  margin-right: 0.25em;
  margin-bottom: 0.25em;
}
</style>
